export const recentEngagement = {
  title: "Recent Engagements",
  headers: ["subject", "company"],
  data: [
    {
      name: "The results to our user testing",
      tracking: false,
      type: "Abstergo Ltd"
    },
    {
      name: "Build prototypes without code",
      tracking: false,
      type: "Acme Co."
    },
    {
      name: "Your account with us",
      tracking: false,
      type: "Barone LLC."
    },
    {
      name: "Welcome to startmail",
      tracking: false,
      type: "Biffco Enterprises Ltd."
    }
  ]
};
